(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fizzy-quality-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fizzy-quality-stories'))customElements.define('fizzy-quality-stories',class extends HTMLElement{
 connectedCallback(){this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal};this.track=this.querySelector('.fizzy-quality-stories__track');this.prev=this.querySelector('[data-story-prev]');this.next=this.querySelector('[data-story-next]');this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const updateNow=()=>{this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;};
 const update=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;updateNow();});};
 this.querySelector('.fizzy-quality-stories__controls').hidden=this.track.children.length<2;
 const go=direction=>this.track.scrollBy({left:direction*(this.track.clientWidth+24),behavior:this.reduced.matches?'instant':'smooth'});
 this.prev.addEventListener('click',()=>go(-1),opts);this.next.addEventListener('click',()=>go(1),opts);
 this.track.addEventListener('scroll',update,{...opts,passive:true});window.addEventListener('resize',update,{...opts,passive:true});
 this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}},opts);
 document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest?.('.fizzy-quality-stories__slide');if(slide&&this.contains(slide))this.track.scrollTo({left:slide.offsetLeft-this.track.firstElementChild.offsetLeft,behavior:'instant'});},opts);update();
 }disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.frame);this.frame=0;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzy-scroll-reveal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fizzy-scroll-reveal')) {
    customElements.define('fizzy-scroll-reveal', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.content = this.querySelector('.fizzy-reveal__text');
        this.words = [];
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.minimum = Math.max(0.05, Math.min(1, Number(this.dataset.minOpacity) || 0.7));
        if (!this.content || this.dataset.effect === 'none') return;
        const schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateReveal();
          });
        };
        window.addEventListener('scroll', schedule, { passive: true, signal: this.controller.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: this.controller.signal });
        this.motion.addEventListener('change', schedule, { signal: this.controller.signal });
        this.prepareWords();
        if (window.Shopify?.designMode) {
          this.editorObserver = new MutationObserver(() => {
            this.prepareWords();
            schedule();
          });
          this.observeEditor();
        }
        schedule();
      }
      observeEditor() {
        this.editorObserver?.observe(this.content, { childList: true, subtree: true, characterData: true });
      }
      prepareWords() {
        this.editorObserver?.disconnect();
        this.content.querySelectorAll('.fizzy-reveal__word').forEach(word =>
          word.replaceWith(...word.childNodes));
        this.content.normalize();
        this.words = [];
        this.lastProgress = null;
        if (this.dataset.effect === 'words') {
          const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach(node => {
            const fragment = document.createDocumentFragment();
            node.textContent.split(/(\s+)/u).forEach(part => {
              if (!part || /^\s+$/u.test(part)) {
                fragment.append(document.createTextNode(part));
              } else {
                const word = document.createElement('span');
                word.className = 'fizzy-reveal__word';
                word.textContent = part;
                this.words.push(word);
                fragment.append(word);
              }
            });
            node.replaceWith(fragment);
          });
        }
        this.observeEditor();
      }
      updateReveal() {
        if (this.motion.matches) {
          this.lastProgress = null;
          this.content.style.removeProperty('--reveal-opacity');
          this.words.forEach(word => word.style.removeProperty('--reveal-opacity'));
          return;
        }
        const rect = this.content.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1,
          (window.innerHeight * 0.85 - rect.top) / (rect.height + window.innerHeight * 0.5)));
        if (progress === this.lastProgress) return;
        this.lastProgress = progress;
        if (this.dataset.effect === 'text') {
          this.content.style.setProperty('--reveal-opacity', this.minimum + progress * (1 - this.minimum));
        } else {
          this.words.forEach((word, index) => {
            const amount = Math.max(0, Math.min(1, progress * (this.words.length + 2) - index));
            word.style.setProperty('--reveal-opacity', this.minimum + amount * (1 - this.minimum));
          });
        }
      }
      disconnectedCallback() {
        this.editorObserver?.disconnect();
        this.editorObserver = null;
        this.controller?.abort();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.content?.style.removeProperty('--reveal-opacity');
        this.words?.forEach(word => word.replaceWith(...word.childNodes));
        this.content?.normalize();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fizzy-story-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fizzy-story-slider'))customElements.define('fizzy-story-slider',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.fz-story__track');this.cards=[...this.querySelectorAll('.fz-story__card')];if(!this.track||!this.cards.length)return;
  this.abort=new AbortController();const opts={signal:this.abort.signal};this.index=0;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
  this.update=()=>{this.classList.toggle('fz-story--scrollable',this.track.scrollWidth>this.track.clientWidth+2)};
  this.go=(dir)=>{const step=this.cards.length>1?this.cards[1].offsetLeft-this.cards[0].offsetLeft:this.cards[0].clientWidth;this.track.scrollTo({left:this.track.scrollLeft+dir*step,behavior:this.reduced.matches?'instant':'smooth'})};
  this.track.addEventListener('dragstart',e=>{if(e.target.closest('img,a'))e.preventDefault()},opts);
  this.track.addEventListener('pointerdown',e=>{
   this.skipClick=false;
   if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,summary,details,input,textarea,select')||this.track.scrollWidth<=this.track.clientWidth+2)return;
   this.drag={id:e.pointerId,x:e.clientX,left:this.track.scrollLeft,moved:false};
   if(!e.target.closest('a')){e.preventDefault();this.track.focus({preventScroll:true});this.track.setPointerCapture(e.pointerId)}
  },opts);
  this.track.addEventListener('pointermove',e=>{if(!this.drag||e.pointerId!==this.drag.id)return;if(e.buttons===0){endDrag(e);return}const dx=e.clientX-this.drag.x;if(Math.abs(dx)>5&&!this.drag.moved){this.drag.moved=true;this.track.classList.add('is-dragging');this.track.setPointerCapture(e.pointerId)}if(this.drag.moved){e.preventDefault();this.track.scrollLeft=this.drag.left-dx}},opts);
  const endDrag=e=>{if(!this.drag||e.pointerId!==this.drag.id)return;this.skipClick=this.drag.moved;this.drag=null;this.track.classList.remove('is-dragging');if(this.track.hasPointerCapture(e.pointerId))this.track.releasePointerCapture(e.pointerId)};
  this.track.addEventListener('click',e=>{if(this.skipClick&&e.detail>0){e.preventDefault();e.stopPropagation();this.skipClick=false}},{...opts,capture:true});
  this.track.addEventListener('pointerup',endDrag,opts);this.track.addEventListener('pointercancel',endDrag,opts);this.track.addEventListener('lostpointercapture',endDrag,opts);
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(e.key==='ArrowRight'?1:-1)}if(e.key==='Home'||e.key==='End'){e.preventDefault();this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:this.reduced.matches?'instant':'smooth'})}},opts);
  this.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('details[open]');if(open){open.open=false;open.querySelector('summary').focus()}}},opts);
  this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{const link=d.closest('.fz-story__card').querySelector('.fz-story__card-link');if(link)link.toggleAttribute('inert',d.open);if(d.open)this.querySelectorAll('details[open]').forEach(other=>{if(other!==d)other.open=false})},opts));
  document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.fz-story__card');if(card&&this.contains(card))this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'})},opts);
  this.resize=new ResizeObserver(this.update);this.resize.observe(this.track);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
